<script>
    import routes from '$lib/config/header';
</script>

<div>
    {#each routes as { route, label } (route)}
        <a href={route} >
            <span>{label}</span>
        </a>
    {/each}
</div>

<style>

</style>